import {
  Tab,
  TabPanel,
  Tabs,
  TabsBody,
  TabsHeader,
  Typography,
  Card,
  CardBody,
} from "@material-tailwind/react";
import { useSelector } from "react-redux";
import Overview from "./Overview";
import PsiloScreen from "./PsiloScreen";
import Appointments from "./Appointments";
import Messages from "./Messages";
import { Box } from "@mui/material";

const data = [
  {
    label: "Overview",
    value: "overview",
    desc: <Overview />,
  },
  {
    label: "Messages",
    value: "messages",
    desc: <Messages />,
  },
  // {
  //   label: "Appointments",
  //   value: "appointments",
  //   desc: <Appointments />,
  // },
  {
    label: "PsiloScreen",
    value: "psiloScreen",
    desc: <PsiloScreen />,
  },
];
const SeekerDetails = () => {
  const { selectedSeekerDetails } = useSelector((state) => state.dataFlow);

  return (
    <>
      <Box
        id="scrollableDiv"
        className="max-h-[calc(100vh-230px)]  md:max-h-[calc(100vh-220px)] lg:max-h-[calc(100vh-205px)] xl:max-h-[calc(100vh-205px)] "
        sx={{
          overflowY: "scroll",
          display: "flex",
          flexDirection: "column-reverse",
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <div>
          <div className="flex items-center hover:cursor-pointer">
            <div className="flex flex-col justify-center ml-2">
              <Typography variant="h6" color="blue-gray">
                Seeker Details -{" "}
                {selectedSeekerDetails?.attendees?.user?.firstName}
              </Typography>
            </div>
          </div>
        </div>
        <div className="sm:!p-3 !p-1">
          {/* <Tabs value="overview">
              <TabsHeader>
                {data.map(({ label, value }) => (
                  <Tab key={value} value={value}>
                    {label}
                  </Tab>
                ))}
              </TabsHeader>
              <TabsBody>
                {data.map(({ value, desc }) => (
                  <TabPanel key={value} value={value}>
                    {desc}
                  </TabPanel>
                ))}
              </TabsBody>
            </Tabs> */}
          <Tabs value="overview">
            <TabsHeader>
              {data.map(({ label, value }) => (
                <Tab key={value} value={value}>
                  {label}
                </Tab>
              ))}
            </TabsHeader>
            <TabsBody>
              {data.map(({ value, desc }) => (
                <TabPanel key={value} value={value}>
                  {desc}
                </TabPanel>
              ))}
            </TabsBody>
          </Tabs>
        </div>
      </Box>
    </>
  );
};

export default SeekerDetails;
